export default __webpack_public_path__ + "static/media/Mobile-09.f86b0119.jpg";